'use strict';exports.__esModule = true;var _constants = require('../constants');exports.default =

{
  initialize: function initialize() {var siteId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.mouseFlowSiteId;var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return new Promise(function (res) {
      if (!__CLIENT__ || global.window.hj) {
        return res();
      }

      // eslint-disable-next-line func-names
      window.hj = window.hj || function () {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
        (window.hj.q = window.hj.q || []).push(args);
      };

      // global.window.hj = options.length ? [...options] : ['stop'];
      window._hjSettings = { hjid: 879528, hjsv: 6 };
      var hj = document.createElement('script');
      hj.type = 'text/javascript';
      hj.async = true;
      hj.src = '//static.hotjar.com/c/hotjar-' + window._hjSettings.hjid + '.js?sv=' + window._hjSettings.hjsv;
      global.document.querySelector('head').appendChild(hj);
      return res();
    });
  },
  // initialize(siteId = mouseFlowSiteId, options = []) {
  //   return new Promise((res) => {
  //     if (!__CLIENT__ || global.window._mfq) {
  //       return res();
  //     }
  //
  //     global.window._mfq = options.length ? [...options] : ['stop'];
  //
  //     const mf = document.createElement('script');
  //     mf.type = 'text/javascript';
  //     mf.async = true;
  //     mf.src = `//cdn.mouseflow.com/projects/${siteId}.js`;
  //     global.document.querySelector('head').appendChild(mf);
  //     return res();
  //   });
  // },
  startRecording: function startRecording() {
    // global.window._mfq.push('start');
  },
  tagRecord: function tagRecord(tag) {
    // global.window._mfq.push(['tag', tag]);
  },
  stopRecording: function stopRecording() {
    // global.window._mfq && global.window._mfq.push('stop');
  },
  stopSession: function stopSession() {
    // global.window._mfq.push('stopSession');
  } };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/services/MouseFlowService.js
// module id = 1290
// module chunks = 0